import React from "react";

const Career = () => {
   return(<h1>This is Career</h1>);
};
export default Career;